import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { AccessDatatable } from '@/react/portainer/access-control/AccessManagement/AccessDatatable/AccessDatatable';
import { withCurrentUser } from '@/react-tools/withCurrentUser';

export const rbacModule = angular
  .module('portainer.app.react.components.rbac', [])
  .component(
    'accessDatatable',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AccessDatatable))), [
      'dataset',
      'inheritFrom',
      'isUpdateEnabled',
      'onRemove',
      'onUpdate',
      'showRoles',
      'showWarning',
      'tableKey',
      'policyId',
      'policyName',
    ])
  ).name;
